<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>最大关卡奖励</span>
          <clear-cache-apply :url="'/config/common-config/index'" />
          <sync-data />
        </div>

        <el-form class="demo-form-inline">
          <!--          <el-form-item label="最大等级">-->
          <!--            <el-input v-model.number="formData.maxLevel" style="width: 100px;" placeholder="最大等级" />-->
          <!--          </el-form-item>-->
          <el-form-item label="金币">
            <el-select v-model="formData.coins.coins" style="width: 130px;" placeholder="请选择">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.label" />
            </el-select>
            <el-input v-model.number="formData.coins.bet" style="margin-left: 10px;width: 100px;" placeholder="金币" />
          </el-form-item>
          <el-form-item label="体力">
            <el-input v-model.number="formData.spins" style="width: 100px;" placeholder="体力" />
          </el-form-item>
          <el-form-item label="道具奖励">
            <el-card class="box-card">
              <commReward v-model="formData.props" />
            </el-card>
          </el-form-item>
          <el-button v-permisaction="['config:maxLevelReward:add']" type="primary" @click="onSubmit()">保存</el-button>
        </el-form>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { delCardProcess } from '@/api/config/card-pro'
import { getRewardType } from '@/api/config/slot'
import { getCfgByLevel, updateCfgByLevel } from '@/api/config/sys-cfg'
import commReward from '@/components/Reward/index.vue'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'
import SyncData from '@/components/syncData/index.vue'

export default {
  name: 'MaxLevelRecord',
  components: {
    SyncData,
    ClearCacheApply,
    commReward
  },
  data() {
    return {
      total: 0,
      options: [],
      rewardType: [],
      formData:
        {
          'maxLevel': 0,
          'coins': {
            'coins': 'money1',
            'bet': 0
          },
          'spins': 200,
          'props': [
            { 'propsId': 3, 'skin': 0, 'num': 1 }
          ]
        },
      skinId: [62, 19],
      chessId: [],
      areaId: []
    }
  },
  created() {
    this.getTables()
    this.getRewardTypeData()
  },
  methods: {
    onSubmit() {
      for (const i in this.formData.props) {
        const prop = this.formData.props[i]
        if (prop.propsId === 65) {
          this.formData.props[i].num *= 10000
        }
      }
      const data = JSON.stringify(this.formData)
      console.log(data)
      if (data.length < 1) {
        this.msgError('没有需要提交的数据')
      }
      updateCfgByLevel({ data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getRewardTypeData() {
      getRewardType().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.rewardType.push({ 'label': res.data[i], 'value': parseInt(i) })
          }
        }
      })
    },
    getTables() {
      getCfgByLevel().then(res => {
        if (res.code === 200) {
          this.formData = res.data
          for (const i in this.formData.props) {
            const prop = this.formData.props[i]
            if (prop.propsId === 65) {
              this.formData.props[i].num /= 10000
            }
          }
        } else {
          this.msgError(res.msg)
        }
      })
    },
    add() {
      this.formData.props.push({ 'propsId': 3, 'skin': 0, 'num': 1 })
    },
    del(id, index) {
      if (id > 0) {
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delCardProcess({ id: id }).then(res => {
            if (res.code === 200) {
              this.msgSuccess(res.msg)
            } else {
              this.msgError(res.msg)
            }
          })
        })
      }

      this.formData = this.formData.filter((item, key) => {
        return key !== index
      })
    }
  }
}
</script>

<style scoped>
</style>
